<script>
import NavBar from '@components/nav-bar.vue'
import { store } from '../../state/store'
import Modal from '../../components/modal.vue'
import FooterComponent from '../../components/footer.vue'
import ErrorAlert from '../../components/error-alert.vue'
import SystemTestService from '@services/business/system-test.service'
import { Slide } from 'vue-burger-menu'
import storageService from '@services/storage.service'
import brinkshomeIcons from '@assets/images/brinkshome_icons.svg'
import { phoneNumbers } from '../../models/enums'
import router from '../index'

const MAX_TEST_HOURS = 12
const TWO_HOUR_TEST = 2
const FOUR_HOUR_TEST = 4
const MINIMUM_TEST_DURATION = 2
export const TEST_VARIANCE_MINUTES = 2

export default {
  components: { NavBar, Modal, FooterComponent, ErrorAlert, Slide },
  data() {
    return {
      state: store.state,
      extendTestDuration: 2,
      generalPhoneNumber: phoneNumbers.GENERAL,
      testDurationOptions: [
        { text: '2 HOUR', value: 2 },
        { text: '4 HOUR', value: 4 },
      ],
      now: Date.now(),
      TWO_HOUR_TEST: TWO_HOUR_TEST,
      FOUR_HOUR_TEST: FOUR_HOUR_TEST,
      jobRoutes: [
        {
          route: '/site-details',
          description: 'Site Details',
          icon: 'icon-clipboard',
          id: 'btn-menu-site-details',
        },
        {
          route: '/event-history',
          description: 'Event History',
          icon: 'icon-calendar',
          id: 'btn-menu-event-history',
        },
        {
          route: '/',
          description: 'Job Lookup',
          icon: 'icon-search',
          id: 'btn-menu-job-lookup',
        },
        {
          route: '/help',
          description: 'Help',
          icon: 'icon-circle-question',
          id: 'btn-menu-help',
        },
      ],
      isLoading: false,
    }
  },
  computed: {
    listOfAvailableMenuItems: function() {
      if (
        router.currentRoute.name === 'select-job-type' ||
        router.currentRoute.name === 'job-lookup'
      ) {
        return this.jobRoutes.filter((jr) => jr.id === 'btn-menu-help')
      }
      return this.jobRoutes
    },
    systemTestRemainingValue: function() {
      if (
        this.state.systemTest.onTest &&
        this.state.systemTest.localExpireDate
      ) {
        return (
          new Date(this.state.systemTest.localExpireDate).getTime() -
          new Date(this.now).getTime()
        )
      } else {
        return 0
      }
    },
    systemTestRemaining: function() {
      return this.convertMS(this.systemTestRemainingValue)
    },
    fifteenMinutesRemaining: function() {
      var fifteenMinutes = 900000
      return (
        this.state.systemTest.onTest &&
        new Date(this.state.systemTest.localExpireDate).getTime() -
          new Date(this.now).getTime() <
          fifteenMinutes
      )
    },
    openExtendTestModal: function() {
      return (
        this.fifteenMinutesRemaining &&
        !this.state.fifteenMinutesAcknowledged &&
        !this.willExtensionViolateMaxHours(MINIMUM_TEST_DURATION)
      )
    },
    openExceededMaxDurationModal: function() {
      return (
        this.fifteenMinutesRemaining &&
        !this.state.fifteenMinutesAcknowledged &&
        this.willExtensionViolateMaxHours(MINIMUM_TEST_DURATION)
      )
    },
    validTestDurationOptions: function() {
      return this.testDurationOptions.filter(
        (option) => !this.willExtensionViolateMaxHours(option.value)
      )
    },
  },
  watch: {
    systemTestRemainingValue(newValue) {
      if (newValue <= 0) {
        // TODO refactor to use constructor once it is created
        this.state.systemTest.onTest = false
        this.state.systemTest.localEffectiveDate = ''
        this.state.systemTest.localExpireDate = ''
      }
    },
  },
  created() {
    var self = this
    setInterval(function() {
      self.now = Date.now()
    }, 30000)
  },
  methods: {
    getIcon(icon) {
      return brinkshomeIcons + '#' + icon
    },
    signOut() {
      storageService.removeJob()
      storageService.removeAccount()
      window.location.href = window.location.origin + '/.auth/logout'
    },
    extendSystemTest() {
      this.isLoading = true
      SystemTestService.extendSystemTest(this.extendTestDuration)
        .then(() => {
          this.isLoading = false
          store.resetFifteenMinutesAcknowledged()
        })
        .catch((err) => {
          this.isLoading = false
          console.log(JSON.stringify(err))
          store.presentErrorAlert('Unable to extend system tests.')
        })
    },
    closeModal() {
      store.setFifteenMinutesAcknowledged()
    },
    updateExtendTestDuration(value) {
      this.extendTestDuration = value
    },
    willExtensionViolateMaxHours(extHours) {
      return (
        new Date(this.state.systemTest.localExpireDate).getTime() +
          this.convertHoursToMS(extHours) >
        new Date(this.state.systemTest.localEffectiveDate).getTime() +
          this.convertHoursToMS(MAX_TEST_HOURS) +
          this.convertMinutesToMS(TEST_VARIANCE_MINUTES)
      )
    },
    convertMS(ms) {
      var d, h, m, s
      s = Math.floor(ms / 1000)
      m = Math.floor(s / 60)
      s = s % 60
      h = Math.floor(m / 60)
      m = m % 60
      d = Math.floor(h / 24)
      h = h % 24
      h += d * 24
      return h + 'h ' + m + 'm'
    },
    convertHoursToMS(hours) {
      return hours * 3600000
    },
    convertMinutesToMS(minutes) {
      return minutes * 60000
    },
    changeRoute(route) {
      this.$router.push(route)
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.navbar_container">
      <NavBar :class="$style.navbar" />
    </div>

    <Slide right :cross-icon="false">
      <div :class="$style.menu_close">
        <svg :class="$style.menu_close_icon" class="icon">
          <use
            xlink:href="../../assets/images/brinkshome_icons.svg#icon-delete"
          ></use>
        </svg>
      </div>
      <div class="link-container">
        <div
          v-for="route in listOfAvailableMenuItems"
          :key="route.route"
          :value="route.route"
        >
          <button
            :id="route.id"
            class="btn btn-link"
            @click="changeRoute(route.route)"
          >
            <svg class="btn__icon btn__icon--left icon">
              <use :href="getIcon(route.icon)"></use></svg
            >{{ route.description }}</button
          >
        </div>
        <div :class="$style.sign_out">
          <button id="btn-menu-sign-out" class="btn btn-link" @click="signOut">
            <svg class="btn__icon btn__icon--left icon icon-door">
              <use
                href="../../assets/images/brinkshome_icons.svg#icon-door"
              ></use>
            </svg>
            Sign Out</button
          >
        </div>
      </div>
    </Slide>

    <slot />
    <Modal v-if="openExceededMaxDurationModal" @close="closeModal">
      <div slot="header">
        <h3 :class="$style.extend_test_modal_header"
          >TEST REMAINING: {{ systemTestRemaining }}</h3
        >
      </div>
      <div slot="body">
        <p
          >You have exceeded the maximium system test extension time. To extend
          the system test, please call Field Services.</p
        >
        <a
          id="link-max-test-duration-phone"
          :href="'tel:' + generalPhoneNumber"
        >
          {{ generalPhoneNumber }}
        </a>
      </div>
      <FooterComponent
        slot="footer"
        secondary-btn-type="link"
        secondary-btn-text="CLOSE"
        :secondary-btn-callback="closeModal"
        :class="$style.footer_container_override"
      ></FooterComponent>
    </Modal>

    <Modal v-if="openExtendTestModal" @close="closeModal">
      <div slot="header">
        <ErrorAlert></ErrorAlert>
        <h3 :class="$style.extend_test_modal_header"
          >TEST REMAINING: {{ systemTestRemaining }}</h3
        >
      </div>
      <div slot="body">
        <div v-show="isLoading" :class="$style.modal_spinner_container">
          <div class="spinner"></div>
        </div>
        <div v-show="!isLoading">
          <ErrorAlert></ErrorAlert>
          <p>Would you like to extend the system test?</p>
          <div :class="$style.extend_test_modal_radio_btn_container">
            <div class="row">
              <div
                v-for="option in validTestDurationOptions"
                :key="option.value"
                :value="option.value"
                :class="$style.extend_test_modal_radio_btns"
              >
                <h5 :class="$style.duration_time_header">{{ option.text }}</h5>
              </div>
            </div>
            <div class="row">
              <div
                v-for="option in validTestDurationOptions"
                :key="option.value"
                :value="option.value"
                :class="$style.extend_test_modal_radio_btns"
              >
                <input
                  v-model="extendTestDuration"
                  :class="$style.enhance_radio_btn"
                  type="radio"
                  :value="option.value"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterComponent
        slot="footer"
        secondary-btn-type="link"
        secondary-btn-text="CANCEL"
        :secondary-btn-callback="closeModal"
        primary-btn-text="EXTEND"
        :primary-btn-callback="extendSystemTest"
        :primary-btn-disable-state="isLoading"
        primary-btn-id="btn-modal-extend-site-test"
        :class="$style.footer_container_override"
      ></FooterComponent>
    </Modal>
  </div>
</template>
<style>
/* Overriding hover elements for touch devices */
.link-container {
  float: left;
  width: 83%;
}

.can-touch .btn-primary:hover {
  color: #fff;
  background-color: #0033a0;
  border-color: #0033a0;
}

.can-touch .btn-secondary:hover {
  color: #fff;
  background-color: #637581;
  border-color: #637581;
}

.can-touch .btn-link:hover {
  font-weight: 400;
  color: #0033a0;
  background-color: transparent;
}

/* Adding important tags to override css of component */
.bm-burger-bars {
  z-index: 1001;
  background-color: #fff !important;
}
.bm-overlay {
  background: #f9f7f5 !important;
}
.bm-menu {
  z-index: 1002 !important;
  padding-top: 0 !important;
  background-color: #444 !important;
}
.bm-burger-button {
  position: fixed !important;
  top: 20px !important;
  right: 25px !important;
  z-index: 1001;
  width: 30px !important;
  height: 25px !important;
}
.bm-item-list {
  margin-top: 1em;
  margin-left: 1em !important;
  font-weight: bold;
}

.bm-item-list > * {
  display: inline-block !important;
  padding: 0 !important;
}

.bm-item-list button {
  padding: 0;
  margin: 0;
  color: #fff;
  text-align: left;
}

.bm-item-list button:hover {
  color: #fff;
}
</style>

<style lang="scss" module>
@import '@design';
.menu_close {
  width: 7%;
  color: $color-white;
  cursor: pointer;
}

.menu_close_icon {
  font-size: 30px;
}

.sign_out {
  position: absolute;
  bottom: 1em;
}

.container {
  min-width: $size-content-width-min;
}

.navbar {
  position: fixed;
  flex-flow: row nowrap;
  justify-content: flex-start;
  height: $height-navbar;
  font-weight: 600;
  background-color: #0033a0;
}

.navbar_container {
  height: $height-navbar;
}

.extend_test_modal_header {
  margin-bottom: 0;
  font-weight: 900;
  color: $color-text-primary;
}

.footer_container_override {
  position: relative;
  height: auto;
  padding-top: 0.5em;
  background-color: $color-body-bg;
}

.duration_time_header {
  font-weight: 900;
  color: $color-text-primary;
}

.enhance_radio_btn {
  transform: scale(2.5);
}

.extend_test_modal_radio_btn_container {
  width: 50%;
  padding-bottom: 1em;
  margin: auto;
}

.extend_test_modal_radio_btns {
  margin: auto;
}

.modal_spinner_container {
  margin: 4em;
}
</style>
